import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    title: (name: string) => string | React.ReactNode;
    labelCancel: string;
    labelSubmit: string;
    labelNotify: string;
    labelSpinner: string;
    search: {
        /** Title for the search input */
        title: string;
        /** Message for no matches */
        noMatches: (name: string) => string | React.ReactNode;
        /** Title for the no matches message */
        noMatchesTitle: string;
        /** Placeholder for the search input */
        placeholder: string;
        /** Label for the loading spinner */
        loading: string;
    };
    message: {
        /** Title for the message input */
        title: string;
        /** Placeholder for the message input */
        placeholder: string;
    };
    existingMembersDetails: string;
    existingProjectMembersDetails: string;
    newOrExistingMembersDetails: string;
    newMemberDetails: string;
    newMemberSeatRate: (rate: string, storageIncrement?: string, isOnTrial?: boolean) => string | React.ReactNode;
    guestLicenseDetails: string;
    invalidEmail: string;
    guestOverLimit: (limit: number) => string | React.ReactNode;
    memberOverLimit: (limit: number) => string | React.ReactNode;
    subscribeTo: string;
    addMoreMembers: string;
    addMoreGuests: string;
    adobeManagedAccount: (resourceType: string) => string | React.ReactNode;
    nonExistingMembersForFolder: string;
    restrictedFolderAlertText: string;
    noSuggestedMembersForFolder: string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Title for the member access form */
            title: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => (name: string) => __intl__.intl().formatMessage({ id: "MemberAccessForm.title?c=l80syoy44inl", defaultMessage: "Invite Members to {name}" }, { name: name }));
                },
                enumerable: true,
                configurable: true
            },
            /** Label for the cancel button */
            labelCancel: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "MemberAccessForm.labelCancel?c=2ojhd8rzicmo0", defaultMessage: "Cancel" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Label for the submit button */
            labelSubmit: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "MemberAccessForm.labelSubmit?c=295qccw425qqf", defaultMessage: "Add" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Label for the notify button */
            labelNotify: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "MemberAccessForm.labelNotify?c=1qnbm454nju3w", defaultMessage: "Add custom message" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Label for the spinner */
            labelSpinner: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "MemberAccessForm.labelSpinner?c=e9g2g3vql98w", defaultMessage: "Suggested Members loading" }));
                },
                enumerable: true,
                configurable: true
            },
            search: {
                get() {
                    return Object.defineProperties({
                        [__intl__.BOUND_INTL]: this[__intl__.BOUND_INTL] ?? __intl__.getIntl()
                    }, {
                        /** Title for the search input */
                        title: {
                            get() {
                                return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "MemberAccessForm.search.title?c=2pj7wzkwhdjdr", defaultMessage: "Suggested" }));
                            },
                            enumerable: true,
                            configurable: true
                        },
                        /** Message for no matches */
                        noMatches: {
                            get() {
                                return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => (name: string) => __intl__.intl().formatMessage({ id: "MemberAccessForm.search.noMatches?c=24dpfy9882qrx", defaultMessage: "No result found for \"{name}\"" }, { name: name }));
                            },
                            enumerable: true,
                            configurable: true
                        },
                        /** Title for the no matches message */
                        noMatchesTitle: {
                            get() {
                                return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "MemberAccessForm.search.noMatchesTitle?c=aq9w62hyjrax", defaultMessage: "Search result" }));
                            },
                            enumerable: true,
                            configurable: true
                        },
                        /** Placeholder for the search input */
                        placeholder: {
                            get() {
                                return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "MemberAccessForm.search.placeholder?c=2gjo6uvnjx4ou", defaultMessage: "Name or email" }));
                            },
                            enumerable: true,
                            configurable: true
                        },
                        /** Label for the loading spinner */
                        loading: {
                            get() {
                                return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "MemberAccessForm.search.loading?c=6yszsa2vwn6", defaultMessage: "loading\u2026" }));
                            },
                            enumerable: true,
                            configurable: true
                        }
                    });
                },
                enumerable: true,
                configurable: true
            },
            message: {
                get() {
                    return Object.defineProperties({
                        [__intl__.BOUND_INTL]: this[__intl__.BOUND_INTL] ?? __intl__.getIntl()
                    }, {
                        /** Title for the message input */
                        title: {
                            get() {
                                return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "MemberAccessForm.message.title?c=3m7we2cqtl314", defaultMessage: "Message" }));
                            },
                            enumerable: true,
                            configurable: true
                        },
                        /** Placeholder for the message input */
                        placeholder: {
                            get() {
                                return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "MemberAccessForm.message.placeholder?c=34hqb2elfnc1", defaultMessage: "Add a message (optional)" }));
                            },
                            enumerable: true,
                            configurable: true
                        }
                    });
                },
                enumerable: true,
                configurable: true
            },
            /** Label for the existing members details */
            existingMembersDetails: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "MemberAccessForm.existingMembersDetails?c=3uapivc4k7c9s", defaultMessage: "Add an existing Member" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Label for the existing project members details */
            existingProjectMembersDetails: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "MemberAccessForm.existingProjectMembersDetails?c=1pt5pmdalawxd", defaultMessage: "Add an existing Project Member" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Label for the new or existing members details */
            newOrExistingMembersDetails: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "MemberAccessForm.newOrExistingMembersDetails?c=19mk40os5rn44", defaultMessage: "Add a new or existing Member" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Label for the new member details */
            newMemberDetails: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "MemberAccessForm.newMemberDetails?c=u8s63antet5f", defaultMessage: "New members will be added for\u00A0" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Label for the new member seat rate */
            newMemberSeatRate: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => (rate: string, storageIncrement?: string, isOnTrial?: boolean) => __intl__.intl().formatMessage({ id: "MemberAccessForm.newMemberSeatRate?c=3tciaz3fw7d08", defaultMessage: "{storageIncrement, select, true {New members come with {storageIncrement} storage for {rate} (plus tax)} other {New members will be added for {rate} (plus tax)}}{isOnTrial, select, true { after free trial period} other {}}." }, { storageIncrement: storageIncrement, rate: rate, isOnTrial: isOnTrial }));
                },
                enumerable: true,
                configurable: true
            },
            /** Label for the guest license details */
            guestLicenseDetails: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "MemberAccessForm.guestLicenseDetails?c=3cykrn8fkl3z2", defaultMessage: "Add a free Guest for single-project access" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Label for the invalid email */
            invalidEmail: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "MemberAccessForm.invalidEmail?c=38jjew13e1v3n", defaultMessage: "Invalid email address" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Label for the guest over limit */
            guestOverLimit: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => (limit: number) => __intl__.intl().formatMessage({ id: "MemberAccessForm.guestOverLimit?c=1apv4umh1yzhe", defaultMessage: "Exceeded account limit of {limit} free Guests." }, { limit: limit }));
                },
                enumerable: true,
                configurable: true
            },
            /** Label for the member over limit */
            memberOverLimit: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => (limit: number) => __intl__.intl().formatMessage({ id: "MemberAccessForm.memberOverLimit?c=3h1i0b8uskaez", defaultMessage: "Exceeded account limit of {limit} Members." }, { limit: limit }));
                },
                enumerable: true,
                configurable: true
            },
            /** Label for the subscribe to */
            subscribeTo: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "MemberAccessForm.subscribeTo?c=34gko3yig5244", defaultMessage: "subscribe to" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Label for the add more members */
            addMoreMembers: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "MemberAccessForm.addMoreMembers?c=b0bznti1z28y", defaultMessage: "To add more members," }));
                },
                enumerable: true,
                configurable: true
            },
            /** Label for the add more guests */
            addMoreGuests: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "MemberAccessForm.addMoreGuests?c=3h7ojyynnj4of", defaultMessage: "To add more free guests," }));
                },
                enumerable: true,
                configurable: true
            },
            /** Label for the adobe managed account */
            adobeManagedAccount: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => (resourceType: string) => __intl__.intl().formatMessage({ id: "MemberAccessForm.adobeManagedAccount?c=2ru6cx896wgn6", defaultMessage: "To add new members to this {var}, contact your Adobe administrator." }, { var: resourceType.toLowerCase() }));
                },
                enumerable: true,
                configurable: true
            },
            /** Label for the non existing members for folder */
            nonExistingMembersForFolder: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "MemberAccessForm.nonExistingMembersForFolder?c=1ra9r1sszksap", defaultMessage: "Only existing Project members can be added to Restricted folders" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Label for the restricted folder alert text */
            restrictedFolderAlertText: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "MemberAccessForm.restrictedFolderAlertText?c=1aq33d8pr419j", defaultMessage: "To specify which project members have access to this folder, you\u2019ll need to make this folder restricted." }));
                },
                enumerable: true,
                configurable: true
            },
            /** Label for the no suggested members for folder */
            noSuggestedMembersForFolder: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "MemberAccessForm.noSuggestedMembersForFolder?c=s1w2l9gqc8c7", defaultMessage: "There are no project members left to invite. The account owner and content admins already have full access to all restricted folders." }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
